var ratingsMixin = {
	methods: {
		getStars: function (rating) {
			let ratings = [];

			// if there is a decimal
			if (rating % 1 != 0) {
				const wholeNumbers = Math.floor(rating);
				for (let i = 0; i < wholeNumbers; i++) {
					ratings.push('');
				}

				ratings.push('half-star');

				const remainder = 5 - (rating + 0.5);
				for (let j = 0; j < remainder; j++) {
					ratings.push('text-gray-200');
				}
			} else {
				const remainder = 5 - rating;

				for (let step = 0; step < rating; step++) {
					ratings.push('');
				}

				for (let step = 0; step < remainder; step++) {
					ratings.push('text-gray-200');
				}
			}

			return ratings;
		},
	},
};
